function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isArray } from 'vega-util';
import { isBinning } from '../bin';
import { COLUMN, FACET_CHANNELS, POSITION_SCALE_CHANNELS, ROW } from '../channel';
import { initFieldDef, vgField } from '../channeldef';
import { replaceExprRef } from '../expr';
import * as log from '../log';
import { hasDiscreteDomain } from '../scale';
import { DEFAULT_SORT_OP, isSortField } from '../sort';
import { isFacetMapping } from '../spec/facet';
import { hasProperty, keys } from '../util';
import { isVgRangeStep } from '../vega.schema';
import { buildModel } from './buildmodel';
import { assembleFacetData } from './data/assemble';
import { sortArrayIndexField } from './data/calculate';
import { parseData as _parseData } from './data/parse';
import { assembleLabelTitle as _assembleLabelTitle } from './header/assemble';
import { getHeaderChannel, getHeaderProperty } from './header/common';
import { HEADER_CHANNELS, HEADER_TYPES } from './header/component';
import { parseFacetHeaders } from './header/parse';
import { parseChildrenLayoutSize } from './layoutsize/parse';
import { ModelWithField } from './model';
import { assembleDomain, getFieldFromDomain } from './scale/domain';
import { assembleFacetSignals } from './selection/assemble';
import { isTimerSelection } from './selection';
import { MULTI_VIEW_ANIMATION_UNSUPPORTED } from '../log/message';
export function facetSortFieldName(fieldDef, sort, opt) {
  return vgField(sort, _objectSpread({
    suffix: "by_".concat(vgField(fieldDef))
  }, opt));
}
export var FacetModel = /*#__PURE__*/function (_ModelWithField) {
  function FacetModel(spec, parent, parentGivenName, config) {
    var _this;
    _classCallCheck(this, FacetModel);
    _this = _callSuper(this, FacetModel, [spec, 'facet', parent, parentGivenName, config, spec.resolve]);
    _this.child = buildModel(spec.spec, _this, _this.getName('child'), undefined, config);
    _this.children = [_this.child];
    _this.facet = _this.initFacet(spec.facet);
    return _this;
  }
  _inherits(FacetModel, _ModelWithField);
  return _createClass(FacetModel, [{
    key: "initFacet",
    value: function initFacet(facet) {
      // clone to prevent side effect to the original spec
      if (!isFacetMapping(facet)) {
        return {
          facet: this.initFacetFieldDef(facet, 'facet')
        };
      }
      var channels = keys(facet);
      var normalizedFacet = {};
      var _iterator = _createForOfIteratorHelper(channels),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var channel = _step.value;
          if (![ROW, COLUMN].includes(channel)) {
            // Drop unsupported channel
            log.warn(log.message.incompatibleChannel(channel, 'facet'));
            break;
          }
          var fieldDef = facet[channel];
          if (fieldDef.field === undefined) {
            log.warn(log.message.emptyFieldDef(fieldDef, channel));
            break;
          }
          normalizedFacet[channel] = this.initFacetFieldDef(fieldDef, channel);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return normalizedFacet;
    }
  }, {
    key: "initFacetFieldDef",
    value: function initFacetFieldDef(fieldDef, channel) {
      // Cast because we call initFieldDef, which assumes general FieldDef.
      // However, FacetFieldDef is a bit more constrained than the general FieldDef
      var facetFieldDef = initFieldDef(fieldDef, channel);
      if (facetFieldDef.header) {
        facetFieldDef.header = replaceExprRef(facetFieldDef.header);
      } else if (facetFieldDef.header === null) {
        facetFieldDef.header = null;
      }
      return facetFieldDef;
    }
  }, {
    key: "channelHasField",
    value: function channelHasField(channel) {
      return hasProperty(this.facet, channel);
    }
  }, {
    key: "fieldDef",
    value: function fieldDef(channel) {
      return this.facet[channel];
    }
  }, {
    key: "parseData",
    value: function parseData() {
      this.component.data = _parseData(this);
      this.child.parseData();
    }
  }, {
    key: "parseLayoutSize",
    value: function parseLayoutSize() {
      parseChildrenLayoutSize(this);
    }
  }, {
    key: "parseSelections",
    value: function parseSelections() {
      // As a facet has a single child, the selection components are the same.
      // The child maintains its selections to assemble signals, which remain
      // within its unit.
      this.child.parseSelections();
      this.component.selection = this.child.component.selection;
      if (Object.values(this.component.selection).some(function (selCmpt) {
        return isTimerSelection(selCmpt);
      })) {
        log.error(MULTI_VIEW_ANIMATION_UNSUPPORTED);
      }
    }
  }, {
    key: "parseMarkGroup",
    value: function parseMarkGroup() {
      this.child.parseMarkGroup();
    }
  }, {
    key: "parseAxesAndHeaders",
    value: function parseAxesAndHeaders() {
      this.child.parseAxesAndHeaders();
      parseFacetHeaders(this);
    }
  }, {
    key: "assembleSelectionTopLevelSignals",
    value: function assembleSelectionTopLevelSignals(signals) {
      return this.child.assembleSelectionTopLevelSignals(signals);
    }
  }, {
    key: "assembleSignals",
    value: function assembleSignals() {
      this.child.assembleSignals();
      return [];
    }
  }, {
    key: "assembleSelectionData",
    value: function assembleSelectionData(data) {
      return this.child.assembleSelectionData(data);
    }
  }, {
    key: "getHeaderLayoutMixins",
    value: function getHeaderLayoutMixins() {
      var layoutMixins = {};
      var _iterator2 = _createForOfIteratorHelper(FACET_CHANNELS),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var channel = _step2.value;
          var _iterator3 = _createForOfIteratorHelper(HEADER_TYPES),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var headerType = _step3.value;
              var layoutHeaderComponent = this.component.layoutHeaders[channel];
              var headerComponent = layoutHeaderComponent[headerType];
              var facetFieldDef = layoutHeaderComponent.facetFieldDef;
              if (facetFieldDef) {
                var titleOrient = getHeaderProperty('titleOrient', facetFieldDef.header, this.config, channel);
                if (['right', 'bottom'].includes(titleOrient)) {
                  var _layoutMixins$titleAn;
                  var headerChannel = getHeaderChannel(channel, titleOrient);
                  (_layoutMixins$titleAn = layoutMixins.titleAnchor) !== null && _layoutMixins$titleAn !== void 0 ? _layoutMixins$titleAn : layoutMixins.titleAnchor = {};
                  layoutMixins.titleAnchor[headerChannel] = 'end';
                }
              }
              if (headerComponent !== null && headerComponent !== void 0 && headerComponent[0]) {
                // set header/footerBand
                var sizeType = channel === 'row' ? 'height' : 'width';
                var bandType = headerType === 'header' ? 'headerBand' : 'footerBand';
                if (channel !== 'facet' && !this.child.component.layoutSize.get(sizeType)) {
                  var _layoutMixins$bandTyp;
                  // If facet child does not have size signal, then apply headerBand
                  (_layoutMixins$bandTyp = layoutMixins[bandType]) !== null && _layoutMixins$bandTyp !== void 0 ? _layoutMixins$bandTyp : layoutMixins[bandType] = {};
                  layoutMixins[bandType][channel] = 0.5;
                }
                if (layoutHeaderComponent.title) {
                  var _layoutMixins$offset;
                  (_layoutMixins$offset = layoutMixins.offset) !== null && _layoutMixins$offset !== void 0 ? _layoutMixins$offset : layoutMixins.offset = {};
                  layoutMixins.offset[channel === 'row' ? 'rowTitle' : 'columnTitle'] = 10;
                }
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return layoutMixins;
    }
  }, {
    key: "assembleDefaultLayout",
    value: function assembleDefaultLayout() {
      var _this$facet = this.facet,
        column = _this$facet.column,
        row = _this$facet.row;
      var columns = column ? this.columnDistinctSignal() : row ? 1 : undefined;
      var align = 'all';
      // Do not align the cells if the scale corresponding to the direction is indepent.
      // We always align when we facet into both row and column.
      if (!row && this.component.resolve.scale.x === 'independent') {
        align = 'none';
      } else if (!column && this.component.resolve.scale.y === 'independent') {
        align = 'none';
      }
      return _objectSpread(_objectSpread(_objectSpread({}, this.getHeaderLayoutMixins()), columns ? {
        columns: columns
      } : {}), {}, {
        bounds: 'full',
        align: align
      });
    }
  }, {
    key: "assembleLayoutSignals",
    value: function assembleLayoutSignals() {
      // FIXME(https://github.com/vega/vega-lite/issues/1193): this can be incorrect if we have independent scales.
      return this.child.assembleLayoutSignals();
    }
  }, {
    key: "columnDistinctSignal",
    value: function columnDistinctSignal() {
      if (this.parent && this.parent instanceof FacetModel) {
        // For nested facet, we will add columns to group mark instead
        // See discussion in https://github.com/vega/vega/issues/952
        // and https://github.com/vega/vega-view/releases/tag/v1.2.6
        return undefined;
      } else {
        // In facetNode.assemble(), the name is always this.getName('column') + '_layout'.
        var facetLayoutDataName = this.getName('column_domain');
        return {
          signal: "length(data('".concat(facetLayoutDataName, "'))")
        };
      }
    }
  }, {
    key: "assembleGroupStyle",
    value: function assembleGroupStyle() {
      return undefined;
    }
  }, {
    key: "assembleGroup",
    value: function assembleGroup(signals) {
      if (this.parent && this.parent instanceof FacetModel) {
        // Provide number of columns for layout.
        // See discussion in https://github.com/vega/vega/issues/952
        // and https://github.com/vega/vega-view/releases/tag/v1.2.6
        return _objectSpread(_objectSpread({}, this.channelHasField('column') ? {
          encode: {
            update: {
              // TODO(https://github.com/vega/vega-lite/issues/2759):
              // Correct the signal for facet of concat of facet_column
              columns: {
                field: vgField(this.facet.column, {
                  prefix: 'distinct'
                })
              }
            }
          }
        } : {}), _superPropGet(FacetModel, "assembleGroup", this, 3)([signals]));
      }
      return _superPropGet(FacetModel, "assembleGroup", this, 3)([signals]);
    }
    /**
     * Aggregate cardinality for calculating size
     */
  }, {
    key: "getCardinalityAggregateForChild",
    value: function getCardinalityAggregateForChild() {
      var fields = [];
      var ops = [];
      var as = [];
      if (this.child instanceof FacetModel) {
        if (this.child.channelHasField('column')) {
          var field = vgField(this.child.facet.column);
          fields.push(field);
          ops.push('distinct');
          as.push("distinct_".concat(field));
        }
      } else {
        var _iterator4 = _createForOfIteratorHelper(POSITION_SCALE_CHANNELS),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var channel = _step4.value;
            var childScaleComponent = this.child.component.scales[channel];
            if (childScaleComponent && !childScaleComponent.merged) {
              var type = childScaleComponent.get('type');
              var range = childScaleComponent.get('range');
              if (hasDiscreteDomain(type) && isVgRangeStep(range)) {
                var domain = assembleDomain(this.child, channel);
                var _field = getFieldFromDomain(domain);
                if (_field) {
                  fields.push(_field);
                  ops.push('distinct');
                  as.push("distinct_".concat(_field));
                } else {
                  log.warn(log.message.unknownField(channel));
                }
              }
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
      return {
        fields: fields,
        ops: ops,
        as: as
      };
    }
  }, {
    key: "assembleFacet",
    value: function assembleFacet() {
      var _this$component$data$ = this.component.data.facetRoot,
        name = _this$component$data$.name,
        data = _this$component$data$.data;
      var _this$facet2 = this.facet,
        row = _this$facet2.row,
        column = _this$facet2.column;
      var _this$getCardinalityA = this.getCardinalityAggregateForChild(),
        fields = _this$getCardinalityA.fields,
        ops = _this$getCardinalityA.ops,
        as = _this$getCardinalityA.as;
      var groupby = [];
      var _iterator5 = _createForOfIteratorHelper(FACET_CHANNELS),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var channel = _step5.value;
          var fieldDef = this.facet[channel];
          if (fieldDef) {
            groupby.push(vgField(fieldDef));
            var bin = fieldDef.bin,
              sort = fieldDef.sort;
            if (isBinning(bin)) {
              groupby.push(vgField(fieldDef, {
                binSuffix: 'end'
              }));
            }
            if (isSortField(sort)) {
              var field = sort.field,
                _sort$op = sort.op,
                op = _sort$op === void 0 ? DEFAULT_SORT_OP : _sort$op;
              var outputName = facetSortFieldName(fieldDef, sort);
              if (row && column) {
                // For crossed facet, use pre-calculate field as it requires a different groupby
                // For each calculated field, apply max and assign them to the same name as
                // all values of the same group should be the same anyway.
                fields.push(outputName);
                ops.push('max');
                as.push(outputName);
              } else {
                fields.push(field);
                ops.push(op);
                as.push(outputName);
              }
            } else if (isArray(sort)) {
              var _outputName = sortArrayIndexField(fieldDef, channel);
              fields.push(_outputName);
              ops.push('max');
              as.push(_outputName);
            }
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      var cross = !!row && !!column;
      return _objectSpread({
        name: name,
        data: data,
        groupby: groupby
      }, cross || fields.length > 0 ? {
        aggregate: _objectSpread(_objectSpread({}, cross ? {
          cross: cross
        } : {}), fields.length ? {
          fields: fields,
          ops: ops,
          as: as
        } : {})
      } : {});
    }
  }, {
    key: "facetSortFields",
    value: function facetSortFields(channel) {
      var facet = this.facet;
      var fieldDef = facet[channel];
      if (fieldDef) {
        if (isSortField(fieldDef.sort)) {
          return [facetSortFieldName(fieldDef, fieldDef.sort, {
            expr: 'datum'
          })];
        } else if (isArray(fieldDef.sort)) {
          return [sortArrayIndexField(fieldDef, channel, {
            expr: 'datum'
          })];
        }
        return [vgField(fieldDef, {
          expr: 'datum'
        })];
      }
      return [];
    }
  }, {
    key: "facetSortOrder",
    value: function facetSortOrder(channel) {
      var facet = this.facet;
      var fieldDef = facet[channel];
      if (fieldDef) {
        var sort = fieldDef.sort;
        var order = (isSortField(sort) ? sort.order : !isArray(sort) && sort) || 'ascending';
        return [order];
      }
      return [];
    }
  }, {
    key: "assembleLabelTitle",
    value: function assembleLabelTitle() {
      var facet = this.facet,
        config = this.config;
      if (facet.facet) {
        // Facet always uses title to display labels
        return _assembleLabelTitle(facet.facet, 'facet', config);
      }
      var ORTHOGONAL_ORIENT = {
        row: ['top', 'bottom'],
        column: ['left', 'right']
      };
      var _iterator6 = _createForOfIteratorHelper(HEADER_CHANNELS),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var channel = _step6.value;
          if (facet[channel]) {
            var _facet$channel;
            var labelOrient = getHeaderProperty('labelOrient', (_facet$channel = facet[channel]) === null || _facet$channel === void 0 ? void 0 : _facet$channel.header, config, channel);
            if (ORTHOGONAL_ORIENT[channel].includes(labelOrient)) {
              // Row/Column with orthogonal labelOrient must use title to display labels
              return _assembleLabelTitle(facet[channel], channel, config);
            }
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return undefined;
    }
  }, {
    key: "assembleMarks",
    value: function assembleMarks() {
      var _this2 = this;
      var child = this.child;
      // If we facet by two dimensions, we need to add a cross operator to the aggregation
      // so that we create all groups
      var facetRoot = this.component.data.facetRoot;
      var data = assembleFacetData(facetRoot);
      var encodeEntry = child.assembleGroupEncodeEntry(false);
      var title = this.assembleLabelTitle() || child.assembleTitle();
      var style = child.assembleGroupStyle();
      var markGroup = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
        name: this.getName('cell'),
        type: 'group'
      }, title ? {
        title: title
      } : {}), style ? {
        style: style
      } : {}), {}, {
        from: {
          facet: this.assembleFacet()
        },
        // TODO: move this to after data
        sort: {
          field: FACET_CHANNELS.map(function (c) {
            return _this2.facetSortFields(c);
          }).flat(),
          order: FACET_CHANNELS.map(function (c) {
            return _this2.facetSortOrder(c);
          }).flat()
        }
      }, data.length > 0 ? {
        data: data
      } : {}), encodeEntry ? {
        encode: {
          update: encodeEntry
        }
      } : {}), child.assembleGroup(assembleFacetSignals(this, [])));
      return [markGroup];
    }
  }, {
    key: "getMapping",
    value: function getMapping() {
      return this.facet;
    }
  }]);
}(ModelWithField);